// src/ProtectedRoute.js
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const token = localStorage.getItem('token');
  const isGuest = localStorage.getItem('guestUser') === 'true';
  return (token || isGuest) ? <Outlet /> : <Navigate to="/auth/login" replace />;
};

export default ProtectedRoute;
